// The `ecommerce` category — v3's `shop` exclusive group.
//
// v3 tagged each of these with `shop: '<vendor>'` and the Connections page treated the group as
// mutually exclusive per workspace. Split here into `exclusiveGroup` (which group) and
// `exclusiveMember` (which member), because the v3 shape encoded both in one key and the
// suppression rule needs to know both.
//
// Note Shopify's `connect` is its own method: it never posts, it GETs
// `/oauth/shopify/install?shop=&workspace_id=` over the authenticated client and navigates the
// browser to the `install_url` that comes back (`ConnectShopifyFlow`) — the endpoint authenticates
// its caller, so the old top-level navigation landed anonymous. The return leg is the callback
// relocation (ORP-18695).

import type { IntegrationProvider } from '../providers.types'

export const ECOMMERCE_PROVIDERS: readonly IntegrationProvider[] = [
  {
    key: 'shopify_store',
    id: 'shopify_store',
    nameKey: 'integrations.providers.shopify',
    category: 'ecommerce',
    connect: 'shopify',
    configComponent: () => import('../../components/connectors/ShopifyConnector.vue'),
    labelFields: ['name', 'domain', 'shop_id'],
    exclusiveGroup: 'shop',
    exclusiveMember: 'shopify',
    logo: 'shopify',
  },
  {
    key: 'ikas_account',
    id: 'ikas_account',
    nameKey: 'integrations.providers.ikas',
    category: 'ecommerce',
    connect: 'credential',
    configComponent: () => import('../../components/connectors/CredentialProviderConnector.vue'),
    labelFields: ['store_name'],
    authLabelKey: 'integrations.authLabels.apiCredentials',
    exclusiveGroup: 'shop',
    exclusiveMember: 'ikas',
    logo: 'ikas',
  },
  {
    key: 'ticimax_account',
    id: 'ticimax_account',
    nameKey: 'integrations.providers.ticimax',
    category: 'ecommerce',
    connect: 'credential',
    configComponent: () => import('../../components/connectors/CredentialProviderConnector.vue'),
    labelFields: ['domain'],
    authLabelKey: 'integrations.authLabels.domainApiKey',
    exclusiveGroup: 'shop',
    exclusiveMember: 'ticimax',
    logo: 'ticimax',
  },
  {
    key: 'tsoft_account',
    id: 'tsoft_account',
    nameKey: 'integrations.providers.tSoft',
    category: 'ecommerce',
    connect: 'credential',
    configComponent: () => import('../../components/connectors/CredentialProviderConnector.vue'),
    labelFields: ['domain'],
    authLabelKey: 'integrations.authLabels.emailPassword',
    exclusiveGroup: 'shop',
    exclusiveMember: 'tsoft',
    logo: 'tsoft',
  },
]
